import { Api } from '../generated-api-types-project/Api'

export type AuthToken = string

// Nest klient pre /project doc (zoznam projektov, detail, attachment download).
class ApiClientProject {
  apiInstance: Api<AuthToken>

  constructor() {
    this.apiInstance = new Api<AuthToken>({
      baseUrl: `${import.meta.env.VITE_REACT_API2_HOST}`,
      baseApiParams: {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
      },
      securityWorker: (token: AuthToken | null) => {
        return token
          ? {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          : {}
      },
    })
  }

  setAuthToken(newToken: string | null) {
    this.apiInstance.setSecurityData(newToken ? newToken : null)
  }
}

export default ApiClientProject
